module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00004-f4c8666c7aceabab6e12ff85fe06dced.jpg";